module.exports = __webpack_public_path__ + "static/media/hero_image.84938f63.svg";